import React from "react";
import { useTheme } from "react-jss";
import { useSelector } from "react-redux";
import useStyles, { type ChoiceLabelStyleProps } from "./ChoiceLabelRenderer.styles";
import type { Theme } from "../../../types/Theme";
import { ChoiceModel } from "../../../models/ChoiceModel";
import useTranslatable from "../../../hooks/useTranslatable";
import useQuestion from "../../../hooks/useQuestion";
import { QuestionType } from "../../../models/enums/QuestionType";
import { StoreState } from "../../../models/states/StoreState";
import { SurveyQuestionnaireModality } from "../../../models/enums/SurveyQuestionnaireModality";

interface Props {
    choice: ChoiceModel;
    gridRendering?: boolean;
    fontWeight?: number;
}

export default function ChoiceLabelRenderer({ choice, gridRendering, fontWeight }: Props) {
    const theme = useTheme() as Theme;
    const classes = useStyles({ theme, fontWeight } as ChoiceLabelStyleProps);
    const id = `${choice.elementId}_LABEL`;
    const choiceLabel = useTranslatable(choice, "TEXT");
    const question = useQuestion();
    
    const isTelephony = useSelector(
        (state: StoreState) =>
            state.interview.questionnaire?.modality === SurveyQuestionnaireModality.Phone,
    );
    const shouldDisplayCode =
        process.env.NODE_ENV !== 'test' &&
        isTelephony &&
        question !== undefined &&
        (question.type === QuestionType.RadioButton || question.type === QuestionType.CheckBox);
    const displayLabel = shouldDisplayCode && choice.value ? `${choice.value} - ${choiceLabel}` : choiceLabel;

    return (
        !gridRendering && (
            <>
                {theme.DisplayChoiceIcon !== "none" && (
                    <span className={classes.spacer} aria-hidden="true" />
                )}
                <span
                    className={classes.choiceText}
                    id={id}
                    dangerouslySetInnerHTML={{ __html: displayLabel }}
                />
            </>
        )
    );
}
